import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { AuthProvider } from './lib/auth.jsx'
import SessionBoundary from './components/SessionBoundary.jsx'
import App from './App.jsx'
import './index.css'
// The Command Center's mobile card layer. Deliberately a GLOBAL stylesheet
// rather than a CSS module — editing a module's file changes its generated
// class hashes, which is what renames `_tName_…` and silently breaks the
// injected champion-truth painter. See the header of this file.
import './styles/cc-mobile.css'

// The champion trust layer: trust chips on championship rows, the eight-criteria
// panel, Find champion, Set-it-myself, flag and undo.
//
// It shipped for one day as a Netlify snippet injected into the HTML shell, and
// that cost two failures that a pull request would have caught: it was installed
// on the wrong Netlify site and "verified" there while the team saw nothing, and
// it shipped 61 provenance records inside a public asset readable by any
// signed-out visitor. Hence: in the repo.
//
// It holds no business data and does nothing at all until there is a session —
// see the auth gate at the bottom of truthLayer.js.
//
// ⚠️ THIS IS NOW THE AUTHORITATIVE COPY, AND IT WAS NOT BEFORE. The comment here
// used to say this module and the still-live snippet "guard on the same
// window.__SR_TRUTH__ flag, so whichever loads first wins". Whichever loads
// first was never in doubt: the snippet is a classic script at the end of <body>
// and runs during parse, this module is deferred, so the stale copy won every
// single page load and production ran code 95 lines behind this file.
// index.html now claims window.__SR_TRUTH__ in an inline head script, which runs
// earlier still, so the snippet returns at its first line; this module claims
// window.__SR_TRUTH_OWNER__ instead and is unaffected. See truthLayer.js's
// MIGRATION STATE block and tools/compare-truth-layer.mjs.
import initTruthLayer from './features/command-center/trust/truthLayer.js'
initTruthLayer()

// Construct once: the catch-all preserves App's existing nested Routes, auth,
// session keys, pathname/query/hash and browser history. Data-router context
// supplies the supported unsaved-edit blocker; no history monkey-patching.
const router=createBrowserRouter([{path:'*',element:<AuthProvider><SessionBoundary><App /></SessionBoundary></AuthProvider>}])
createRoot(document.getElementById('root')).render(
  <StrictMode><RouterProvider router={router}/></StrictMode>
)
